<template>
  <div class="login">
    <div class="boxtant">
      <div class="loginBox" :style="isQrcodeLogin && { padding: 0 }">
        <img
          v-if="!isSelectCompany"
          class="login-icon"
          :src="!isQrcodeLogin ? loginQrcode : loginPassword"
          @click="isQrcodeLogin = !isQrcodeLogin"
        />
        <wechatLogin
          v-if="isQrcodeLogin"
          @success="wechatLoginSuccess"
          @error="error"
          :baseUrl="baseUrl"
        />
        <div v-else-if="isSelectCompany" class="select-company">
          <div class="select-company-header">
            <p class="formTitle">选择公司</p>
            <span @click="logout">退出登录</span>
          </div>
          <div class="company-box">
            <div
              class="company-item"
              v-for="item in companyList"
              :key="item.id"
              :title="item.name"
              @click="selectCompany(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div v-else class="loginInput">
          <p class="formTitle">用户登录</p>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            autocomplete="on"
            label-position="left"
          >
            <el-form-item prop="userName">
              <span class="svg-container">
                <i class="el-icon-user"></i>
              </span>
              <el-input
                ref="userName"
                v-model="loginForm.userName"
                placeholder="用户名"
                name="userName"
                type="text"
                tabindex="1"
                autocomplete="on"
              />
            </el-form-item>

            <el-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <el-form-item prop="password">
                <span class="svg-container">
                  <i class="el-icon-lock"></i>
                </span>
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="密码"
                  name="password"
                  tabindex="2"
                  autocomplete="on"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                  @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd svg-container" @click="showPwd">
                  <i class="el-icon-view"></i>
                </span>
              </el-form-item>
            </el-tooltip>

            <el-button
              :loading="loading"
              type="primary"
              style="width:100%;margin-bottom:30px;"
              @click.native.prevent="handleLogin"
              >登录</el-button
            >
          </el-form>
          <div class="register" @click="drawer = true">立即注册 ></div>
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div class="registerBox">
        <div class="drawer-title">新用户注册</div>
        <el-form
          ref="registerForm"
          :model="registerForm"
          class="login-form"
          autocomplete="on"
          label-position="left"
        >
          <el-form-item prop="userName">
            <el-input
              ref="userName"
              v-model="registerForm.account"
              placeholder="账号"
              name="userName"
              type="text"
              tabindex="1"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="nickname">
            <el-input
              ref="userName"
              v-model="registerForm.nickname"
              placeholder="昵称"
              name="userName"
              type="text"
              tabindex="1"
              autocomplete="on"
            />
          </el-form-item>

          <div style="display:flex;">
            <div style="margin-right:18px">
              <el-form-item prop="gender">
                <el-select v-model="registerForm.gender" placeholder="性别">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.sex"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="gender">
                <el-date-picker
                  v-model="registerForm.birthday"
                  align="left"
                  type="date"
                  placeholder="生日"
                  value-format="yyyy/MM/dd"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>

          <el-form-item prop="password">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="registerForm.password"
              :type="passwordType"
              placeholder="密码"
              name="password"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
            />
            <span class="show-pwd svg-container" @click="showPwd">
              <i class="el-icon-view"></i>
            </span>
          </el-form-item>

          <el-button
            :loading="loading"
            type="primary"
            style="width:100%;margin-bottom:13px;"
            @click.native.prevent="handleRegister"
            >注册</el-button
          >
        </el-form>
        <div class="register registers">
          <span style="color:#666666">已有账号，</span
          ><span @click="drawer = false">去登陆</span>
        </div>
      </div>
    </el-drawer>

    <div class="internet-content-provider-box">
      Copyright © All Rights Reserved.备案号：<a
        class="internet-content-provider"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >粤ICP备19085808号</a
      >
    </div>
  </div>
</template>

<script>
import Cookie from "@/utils/cookie"; // 验权
import api from "../../../common/api";
import wechatLogin from "common/src/components/wechatLogin.vue";
import loginPassword from "common/src/images/wechatLogin/login-password.png";
import loginQrcode from "common/src/images/wechatLogin/login-qrcode.png";
import cookie from "@/utils/cookie";

export default {
  components: {
    wechatLogin,
  },
  data() {
    let checkUserName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    let checkPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      baseUrl: window.baseConfig.baseUrl,
      isQrcodeLogin: false,
      loginQrcode,
      loginPassword,

      options: [
        { sex: "男", value: 1 },
        { sex: "女", value: 2 },
      ],
      companyName: window.baseConfig.companyName,
      drawer: false,
      direction: "rtl",
      project: window.baseConfig.project,
      titleShow: true,
      loginForm: {
        userName: "",
        password: "",
      },
      loginRules: {
        userName: [{ validator: checkUserName, trigger: "change" }],
        password: [{ validator: checkPassword, trigger: "change" }],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      // redirect: undefined,
      // otherQuery: {},
      registerForm: {
        account: "",
        password: "",
        nickname: "",
        gender: "",
        birthday: "",
      },
      companyList: [],
    };
  },
  mounted() {
    if (!this.isSelectCompany) {
      if (this.loginForm.userName === "") {
        this.$refs?.userName.focus();
      } else if (this.loginForm.password === "") {
        this.$refs?.password.focus();
      }
    } else {
      this.getAccessableCompany();
    }
  },

  computed: {
    isSelectCompany: () => !Cookie.getCookie("companyId") && Cookie.getToken(),
  },
  methods: {
    async selectCompany(item) {
      const { success } = await api.login.bindCompanyOfCurrentSession(item.id);
      if (success) {
        Cookie.setCookie("companyId", item.id);
        this.$router.replace("/");
      }
    },
    async getAccessableCompany() {
      const { success, data } = await api.user.getAccessibleCompany();
      if (success) {
        this.companyList = data;
        if (data.length === 1) {
          this.selectCompany(data[0]);
        }
      }
    },
    async logout() {
      await this.$store.dispatch("user/fedLogOut");
      await window.location.replace(
        `${window.baseConfig.loginServeUrl}/Signout?&redirectUrl=${window.location.href}`
      );
    },
    handleRegister() {
      let vm = this;
      this.$api.user
        .createUser(
          vm.registerForm.account,
          vm.registerForm.password,
          vm.registerForm.nickname,
          vm.registerForm.gender,
          vm.registerForm.birthday
        )
        .then((res) => {
          if (res.success) {
            vm.$message.success("注册成功");
            setTimeout(() => {
              vm.drawer = false;
            }, 1000);
          } else {
            vm.$message.error(res.errorStr);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      let i = this.loginForm.password;
      Cookie.removeCookie("companyId");
      this.$store.dispatch("user/setPassword", i);
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          // this.$store.dispatch('user/login', this.loginForm).then((res) => {
          //   if (res.success) {
          //     this.$router.push('/')
          //   } else {
          //     this.$message.error(res.msg)
          //   }
          // })
          window.location.replace(
            `${window.baseConfig.loginServeUrl}?account=${this.loginForm.userName}&password=${this.loginForm.password}&redirectUrl=${window.location.href}`
          );
        } else {
          return false;
        }
      });
    },
    wechatLoginSuccess(data) {
      Cookie.setToken(data.token);
      this.getAccessableCompany();
    },
    error(errorStr) {
      this.$message.error(errorStr);
    },
    // getOtherQuery(query) {
    //   return Object.keys(query).reduce((acc, cur) => {
    //     if (cur !== "redirect") {
    //       acc[cur] = query[cur];
    //     }
    //     return acc;
    //   }, {});
    // },
  },
};
</script>

<style lang="scss">
$bg: #283443;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login {
  height: 100vh;
  .login-form {
    margin: 0px 10px;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .svg-container {
        width: 40px;
        text-align: center;
      }
      .el-input {
        flex: 1;
      }
    }
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #e6e5e5 inset !important;
        -webkit-text-fill-color: #454545 !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: #e6e5e5;
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: rgba(0, 0, 0, 0.1);
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
caption,
th,
td {
  font-weight: normal;
  text-align: left;
}
a img,
iframe {
  border: medium none;
}
ol,
ul {
  list-style: none outside none;
}
input,
textarea,
select,
button {
  font-family: inherit;
  font-size: 100%;
}
body,
html {
  width: 100%;
  height: 100%;
}
.login {
  width: 100%;
  background: url("../assets/images/login.png") no-repeat center center;
  background-size: 100% 100%;
}
.boxtant {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}
.boxtant i {
  height: 55%;
}
.boxtant i img {
  height: 100%;
}
.loginBox {
  width: 410px;
  overflow: hidden;
  background: #fff;
  border-radius: 0.2rem;
  position: absolute;
  right: 239px;
  top: 50%;
  transform: translateY(-50%);
  padding: 50px;
  box-sizing: border-box;
}
.wechatLogin {
  height: 420px;
  background-color: #fff;
}
.login-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 72px;
  z-index: 111;
  cursor: pointer;
}
.select-company {
  &-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 28px;
    > span {
      color: #0080ff;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .company-box {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 10px;
    .company-item {
      box-sizing: border-box;
      text-align: left;
      height: 32px;
      border: 1px solid #dee3e7;
      line-height: 32px;
      padding: 0 10px;
      border-radius: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      &:hover {
        background-color: #0080ff;
        color: #ffffff;
        border: none;
      }
    }
  }
}
.loginBoxlogo {
  width: 27%;
  height: 20%;
  margin-bottom: 0.5rem;
  overflow: hidden;
  background: #fff;
  border-radius: 0.2rem;
}
.loginInput {
  width: 100%;
  height: 100%;
  .formTitle {
    margin-bottom: 28px;
  }
}
.loginLogo {
  float: left;
  width: 41%;
  height: 100%;
  background: #4da6ff;
}
.span_line {
  padding: 0 0.25rem;
  color: #045892;
  font-weight: bold;
}
.psize {
  font-size: 0.75rem;
}
.form {
  width: 100%;
  height: 100%;
  padding: 4.2% 2.6% 3.7%;
  box-sizing: border-box;
}
.formTitle {
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0080ff;
}
.user,
.pass {
  background: #ebedf0;
  position: relative;
  height: 20%;
  margin-bottom: 3%;
  border-radius: 0.1rem;
  overflow: hidden;
}
.user i,
.pass i {
  display: inline-block;
  height: 100%;
  width: 11%;
  text-align: center;
  position: relative;
}
.user i img,
.pass i img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -0.85rem 0 0 -0.85rem;
}
.user div,
.pass div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 11%;
  right: 0;
}
.user input,
.pass input {
  border: none;
  width: 100%;
  height: 100%;
  background: #ebedf0;
  padding: 0;
  font-size: 1rem;
}
.type,
#error {
  display: none;
}
.submit {
  color: #fff;
  background: #4da6ff;
  border-radius: 0.1rem;
  border: none;
  width: 100%;
  height: 20%;
  letter-spacing: 2.2rem;
  font-size: 1.2rem;
  margin-top: 2%;
  cursor: pointer;
}
.loginTop {
  width: 100%;
  height: 50%;
  position: relative;
}
.loginTopBox {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
}
.loginTopBox i {
  display: inline-block;
  margin-bottom: 1rem;
}
.loginTopTitle {
  color: #fff;
  text-align: center;
  font-weight: bold;
}
.loginBottomTitle {
  font-size: 0.7rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 1.2rem;
  padding: 5% 10%;
}
.copyright {
  letter-spacing: 0.05rem;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
  color: #fff;
  position: absolute;
  bottom: 1.5rem;
  margin: 0 auto;
  width: 100%;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}
.maskBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.maskBackground {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.markTitle {
  color: #fff;
  font-size: 1.2rem;
  line-height: 1.65rem;
  position: absolute;
  text-align: center;
  top: 29.4%;
  width: 100%;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.typeLeft {
  position: absolute;
  top: 39.8%;
  left: 37.2%;
  cursor: pointer;
  z-index: 19950707;
}
.typeLeft p,
.typeRight p {
  color: #fff;
  opacity: 0.5;
  filter: alpha(opacity=50);
  letter-spacing: 0.4.45rem;
  text-shadow: 0 0.1rem 0.2rem;
  margin-top: 1rem;
  text-align: center;
}
.typeLeft i,
.typeRight i {
  display: inline-block;
}
.typeRight {
  position: absolute;
  top: 39.8%;
  left: 54.2%;
  cursor: pointer;
  z-index: 19950707;
}
.login .login-form {
  margin: 0 !important;
}
.register {
  font-size: 16px;
  font-weight: 400;
  color: #0080ff;
  text-align: right;
  cursor: pointer;
}
.registers {
  text-align: left;
}
::v-deep .el-drawer__header {
  display: none;
}
.registerBox {
  width: 384px;
  margin: 0 auto;
}
.registerBox {
  width: 384px;
  margin: 0 auto;
}
.ps {
  width: 340px;
  text-align: center;
  position: absolute;
  bottom: 48px;
  left: 50%;
  transform: translateX(-50%);
}
.ps-1 {
  color: #fff;
  line-height: 0;
  margin-bottom: 20px;
  font-size: 12px;
}
::v-deep .el-icon-date {
  display: none;
}
.drawer-title {
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0080ff;
  letter-spacing: 1px;
  text-align: left;
  margin-bottom: 40px;
  margin-top: 140px;
}
</style>

<style lang="scss" scoped>
.internet-content-provider-box {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  color: #b9b8b8;
  .internet-content-provider {
    text-decoration: none;
    color: #b9b8b8;
    &:hover {
      color: #3a8ee6;
    }
  }
}
</style>
